// extracted by mini-css-extract-plugin
module.exports = {"details":"DeprGroupDetails_details__SflyB"};